/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    ON_PLACE: 'on_place',
    BANK_TRANSFER: 'bank_transfer',
    INSTANT_ONLINE: 'instant_online',
    OTHER: 'other',
};
